var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"primary",attrs:{"fluid":"","fill-height":""}},[_c('LoginForm',{attrs:{"loading":_vm.userLoading},on:{"login":_vm.sendLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }